export const DUMMY_LANG_URL = '/do-not-load/';